import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite"; // 1. Импортируем observer
import { toJS } from "mobx";

import "../style/style.css";
import DataUserLoyalty from "../store/DataUserLoyalty";

import BonusProgress from "../Components/BonusView";
import LogoutPopconfirm from "../Components/LogoutPopconfirm";
import ActiveBtns from "../Components/ActiveBtns";
import profileLogo from "../assets/Ellipse.png";

const Main = observer(() => {
  const navigation = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initUser = () => {
      try {
        const userRaw = localStorage.getItem("user");

        if (!userRaw) {
          const redirectParams = DataUserLoyalty.placeId
            ? `?place_id=${DataUserLoyalty.placeId}`
            : "";
          navigation(`/userLoyalty/registration${redirectParams}`);
          return;
        }

        const parsedUser = JSON.parse(userRaw);

        DataUserLoyalty.savedUser = parsedUser;
      } catch (error) {
        console.error("Ошибка при чтении данных пользователя:", error);
        localStorage.removeItem("user");
        navigation("/userLoyalty/registration");
      } finally {
        setIsLoading(false);
      }
    };

    initUser();
  }, [navigation]);

  const savedUser = toJS(DataUserLoyalty.savedUser);

  if (isLoading) {
    return <div className='loading-state'>Загрузка...</div>;
  }

  if (!savedUser?.user_name) {
    return null;
  }

  return (
    <div className='main'>
      <div className='main__burger'>
        <div className='main__burger_element'></div>
      </div>

      <div className='main__profile'>
        <div className='main__user'>
          <div>
            <div className='profile__conf mb-[20px]'>
              <p className='main__user_text mb-[0]'>Профиль</p>
              <div>
                <LogoutPopconfirm />
              </div>
            </div>

            <div className='user__info'>
              <div className='user__logo mb-[20px]'>
                <img src={profileLogo} alt='Avatar' />
              </div>
              <p className='main__user_text_item'>
                {savedUser.user_name} {savedUser.user_surname} <br />
                <span className='user__phone'>{savedUser.user_mobile}</span>
              </p>
            </div>
          </div>
        </div>

        <BonusProgress savedUser={savedUser} />
      </div>

      <div className='mb-[20px]'>
        <ActiveBtns />
      </div>
    </div>
  );
});

export default Main;
